














import Vue from 'vue'
import { FacilityId, Facility } from '@/core/Facilities'
import FacilityCardWithPrograms from './FacilityCardWithPrograms.vue'

export default Vue.extend({
  name: 'FacilityListWithPrograms',
  components: {
    FacilityCardWithPrograms,
  },
  props: {
    facilities: {
      type: Array as () => Facility[],
      default: () => [],
    },
    favoritedFacilityIds: {
      type: Array as () => FacilityId[],
      default: () => [],
    },
  },
  methods: {
    handleFavoriteClick(facilityId: FacilityId, favorited: boolean) {
      this.$emit('onFavorited', facilityId, favorited)
    },
  },
})
